/**
 * A coluna onde o card está é quem define o desfecho da oportunidade: soltar em
 * "Ganho" é ganhar, em "Perdido" é perder. Os diálogos de criação e de edição
 * derivam o `status` daqui para não existir card numa etapa de ganho ainda
 * marcado como aberto — que é o que o mantém fora dos relatórios de venda.
 */

export type StageType = 'normal' | 'won' | 'lost';
export type OpportunityOutcome = 'open' | 'won' | 'lost';

export function deriveOpportunityStatus(
  stageType?: StageType | null
): OpportunityOutcome {
  if (stageType === 'won') return 'won';
  if (stageType === 'lost') return 'lost';
  return 'open';
}
